import {createContext, type ReactNode, useContext, useState} from 'react';

type TokenContextType = {
    token: string | null;
    setToken: (token: string | null) => void;
};

const TokenContext = createContext<TokenContextType>({
    token: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    setToken: (_a: string | null) => {},
});

type Props = {
    children?: ReactNode;
};

export const TokenContextProvider: React.FC<Props> = ({children}: Props) => {
    const [token, setToken] = useState<string | null>(null);

    return <TokenContext.Provider value={{token, setToken}}>{children}</TokenContext.Provider>;
};

export const useToken = (): TokenContextType => {
    const user = useContext(TokenContext);
    return user;
};
